import AnalyticsComponent from './Analytics';

export const Analytics = AnalyticsComponent;
